/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.empty[_ngcontent-%COMP%]{background-color:#eee}.empty[_ngcontent-%COMP%], .empty-wc[_ngcontent-%COMP%]{position:relative;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvamVua2lucy93b3Jrc3BhY2UvcHJvZHVjdGlvbi1hcmdvcy1mcm9udC9hcmdvcy9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnQvdHgtZW1wdHktc3RhdGUvdHgtZW1wdHktc3RhdGUuY29tcG9uZW50LmNzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL2plbmtpbnMvd29ya3NwYWNlL3Byb2R1Y3Rpb24tYXJnb3MtZnJvbnQvYXJnb3Mvc3JjL2FwcC9zaGFyZWQvY29tcG9uZW50L3R4LWVtcHR5LXN0YXRlL3R4LWVtcHR5LXN0YXRlLmNvbXBvbmVudC5jc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/$$_gendir/app/shared/component/tx-empty-state/tx-empty-state.component.css.shim.ngstyle.ts